import { mods, theme } from '@approvalmax/theme';
import { Button } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import SsoPanel from 'modules/auth/components/SsoPanel/SsoPanel';
import { font } from 'modules/styles';
import styled from 'styled-components';

export const Content = styled.div`
    display: flex;
    align-items: start;
    padding: 40px 60px;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        flex-direction: column;
        align-items: center;
        padding: 0px;
    }
`;

export const Form = styled.div`
    min-width: 0;
    flex: auto;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 15px 0px 15px;
    }
`;

export const Title = styled.div`
    ${font(20, '#000', 'semibold')};
    text-align: center;
    margin-top: 24px;
    margin-bottom: 20px;
`;

export const NextButton = styled(Button)<StyledMods<{ noMarginRight?: boolean }>>`
    margin-top: 20px;
    margin-left: auto;
    margin-right: 60px;

    ${mods('noMarginRight', true)`
        margin-right: 0;
    `};

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        width: calc(100% - 30px);
        position: sticky;
        bottom: 25px;
        margin-top: 0;
        margin-bottom: 25px;
        margin-left: 0;
        margin-right: 0;
    }
`;

export const StyledSsoPanel = styled(SsoPanel)`
    margin-left: 30px;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        margin-left: 0;
        margin-bottom: 25px;
    }
`;

export const ProfileArea = styled.div<StyledMods<{ withSso?: boolean }>>`
    width: 320px;
    margin: 40px 90px;

    ${mods('withSso', true)`
        width: auto;
        margin: 40px 60px;
    `};

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        width: calc(100% - 40px);
        margin: 40px 20px;
    }
`;
